import type {SearchParams} from '@/modules/common/context/QueryParams/models';
import type {AditionProfileParams} from '@travel-frontend/ui-components';

import {type Keyword, KeywordTypes} from '@/api/keywordApi';
import {PAGE_HOTELS, PAGE_OFFERS} from '@/consts';

export const mapAditionProfileParams = ({
  currentPage,
  searchParams,
  keyword,
}: {
  currentPage: string;
  searchParams: SearchParams;
  keyword: Keyword | null | undefined;
}): AditionProfileParams => {
  const aditionProfileParams: AditionProfileParams = {
    um_area: null,
    query: null,
    region: null,
    zielland: null,
    reiseziel: null,
    abflughafen: null,
    zielflughafen: null,
    reisende: null,
    kinder: null,
  };

  if (currentPage === PAGE_HOTELS) {
    aditionProfileParams.um_area = 'aiduDE_IBE3_relaunch2';
  } else if (currentPage === PAGE_OFFERS) {
    aditionProfileParams.um_area = 'aiduDE_IBE4_relaunch2';
  }
  if (keyword) {
    aditionProfileParams.query = keyword.keyword;
    // region (destination)
    if (keyword.type === KeywordTypes.destination) {
      aditionProfileParams.region = keyword.keyword;
    } else if (
      (keyword.type === KeywordTypes.city ||
        keyword.type === KeywordTypes.hotel) &&
      keyword.meta?.destination
    ) {
      aditionProfileParams.region = keyword.meta.destination as string;
    }
    // zielland (country)
    if (keyword.type !== KeywordTypes.country && keyword.meta?.country) {
      aditionProfileParams.zielland = keyword.meta.country as string;
    }
    // reiseziel (city)
    if (keyword.type === 'city') {
      aditionProfileParams.reiseziel = keyword.keyword;
    } else if (keyword.type === KeywordTypes.hotel && keyword.meta?.city) {
      aditionProfileParams.reiseziel = keyword.meta.city as string;
    }
  }
  if (searchParams.airports) {
    aditionProfileParams.abflughafen = searchParams.airports;
  }
  // figuring this one out is complicated with questionable benefit,
  // so we just leave it empty for now to keep things simple.
  aditionProfileParams.zielflughafen = null;
  aditionProfileParams.reisende = String(searchParams.rooms.travellerCount);
  aditionProfileParams.kinder = String(searchParams.rooms.childrenCount);

  return aditionProfileParams;
};
